import { PulseLoader, Text, UnstyledButton } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import { clipSuggestionNameSelector } from 'blocks/ClipSelect/selectors';
import { useClipSelect } from '../../ClipSelectContext';
import { useClipSelectNavigation } from '../../ClipSelectNavigationContext';
import AudioClipSuggestionPreviewCardMenu from './AudioClipSuggestionPreviewCardMenu';
import AudioClipSuggestionPreviewCardVideo from './AudioClipSuggestionPreviewCardVideo';
import { block } from './utils';

export type AudioClipSuggestionPreviewCardProps = {
  clipId: number;
  className?: string;
};

const AudioClipSuggestionPreviewCard: React.FC<AudioClipSuggestionPreviewCardProps> = ({
  clipId,
  className,
}) => {
  const {
    isExporting,
    onSuggestionSelect,
    suggestion,
    suggestionIds,
    updatedSuggestionProjectName,
  } = useClipSelect({
    clipId,
  });
  const [, dispatch] = useClipSelectNavigation();

  const { isPreviewRequested, status } = suggestion || {};

  // Handler for opening detail overlay
  const handleOpenDetailView = () => {
    onSuggestionSelect();
    dispatch({ type: 'DETAIL_VIEW_OPEN' });
  };

  return (
    <UnstyledButton
      as="div"
      className={cn(block(), className)}
      onPress={handleOpenDetailView}
      isDisabled={!isPreviewRequested && status !== 'completed'}
    >
      <div className={block('video-section')}>
        <AudioClipSuggestionPreviewCardVideo videoId={clipId} />
      </div>
      <div className={block('footer')}>
        <Text variant="h5" lineHeight={1.375} className={block('footer-text')}>
          {clipSuggestionNameSelector(
            updatedSuggestionProjectName,
            suggestion,
            suggestionIds,
          )}
        </Text>
        <AudioClipSuggestionPreviewCardMenu
          clipId={clipId}
          clipName={clipSuggestionNameSelector(
            updatedSuggestionProjectName,
            suggestion,
            suggestionIds,
            {
              as: 'string',
            },
          )}
          isDisabled={isExporting}
          onClickCaptions={handleOpenDetailView}
        />
      </div>
      {(isExporting || !suggestion?.videoUrl) && (
        <div className={block('busy-overlay')}>
          <PulseLoader />
        </div>
      )}
    </UnstyledButton>
  );
};

export default AudioClipSuggestionPreviewCard;
